import { TimeSignalAnalytic, TimeSignalAcceptedBy } from 'graphql/types';

export function transformAnalyticsData(
  data: TimeSignalAnalytic | undefined
): Record<string, string | number> {
  if (!data) {
    return {};
  }
  if (data.dimensions.length === 0) {
    return {
      [TimeSignalAcceptedBy.User]: 0,
      [TimeSignalAcceptedBy.System]: 0
    };
  } else {
    const manualAcceptIndex = data.dimensions.findIndex(
      (d) => d.name === TimeSignalAcceptedBy.User
    );
    const manualAcceptCount = data.metrics[manualAcceptIndex]?.totalCount || 0;

    const autoAcceptIndex = data.dimensions.findIndex(
      (d) => d.name === TimeSignalAcceptedBy.System
    );
    const autoAcceptCount = data.metrics[autoAcceptIndex]?.totalCount || 0;

    const totalCount = manualAcceptCount + autoAcceptCount;

    const percentageOfFirstElement = Math.round(
      (data.metrics[0].totalCount / totalCount) * 100
    );
    if (manualAcceptCount === 0) {
      return {
        [data.dimensions[0].name]: percentageOfFirstElement,
        [TimeSignalAcceptedBy.User]: 0
      };
    } else if (autoAcceptCount === 0) {
      return {
        [data.dimensions[0].name]: percentageOfFirstElement,
        [TimeSignalAcceptedBy.System]: 0
      };
    } else {
      const percentageofSecondElement = 100 - percentageOfFirstElement;
      return {
        [data.dimensions[0].name]: percentageOfFirstElement,
        [data.dimensions[1].name]: percentageofSecondElement
      };
    }
  }
}
